import { WfLocalePipe } from '../../i18n/pipe/wf-process-editor-locale.pipe';
import { ApprovalPivot } from './approval-pivot';

export class ApprovalPivotConfig {
    localePipe: WfLocalePipe = null;

    constructor() {
        this.enable = false;
        this.title = '审批要点';
        this.approvalPivots = new Array();
    }
    title: string;
    enable: boolean;
    expand: boolean;
    approvalPivots: Array<ApprovalPivot>;
}
